var map = {
	"./Achievement 2.png": 8507,
	"./app_streaming.png": 7324,
	"./context_based.png": 6378,
	"./first_use.png": 293,
	"./game_streaming.png": 3765,
	"./location_based.png": 3002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6287;